require('./index.scss')
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import CartItem from '@/components/CartItem/ForCart'
import { lineItemKeysSelector } from '@/selectors'

const CartItems = () => {
  const lineItemKeys = useSelector(lineItemKeysSelector)
  const itemCount = useSelector(state => state.cart.itemsTotalCount)

  return (
    <Choose>
      <When condition={itemCount === 0} >
        <div
          className='empty-cart-message u-align--center block type--grey'
          role='status'
        >
          <FormattedMessage id='carts.empty_cart_message' />
        </div>
      </When>
      <Otherwise>
        <ul className='product-info'>
          {lineItemKeys.map(key => (
            <li className='product-info__wrapper' key={key}>
              <CartItem id={key} />
            </li>
          ))}
        </ul>
      </Otherwise>
    </Choose>
  )
}

export default CartItems
